<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.AWS.DedicatedHosting.title") }}</div>
      <div>
        <Button type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:dedicatedHostingResource:update'
          ]"
         :loading="loading" @click="update">{{
          $t("RAM.common.update")
        }}</Button>
        <Button type="primary"
        v-hasPermission="[
            'resourceConfigurationManagement:aws:dedicatedHostingResource:export'
          ]"
         @click="exportList">{{
          $t("common.export")
        }}</Button>
      </div>
    </div>
    <dedicated-hosting-resource-search
      ref="child"
    ></dedicated-hosting-resource-search>
    <table-dedicated-hosting-resource></table-dedicated-hosting-resource>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import DedicatedHostingResourceSearch from "../bsh/DedicatedHostingResourceSearch";
import TableDedicatedHostingResource from "../bsh/TableDedicatedHostingResource";
import Export from "../../aws/Export";
export default {
  name: "DedicatedHostingResource",
  components: {
    DedicatedHostingResourceSearch,
    TableDedicatedHostingResource,
    Export,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    update: function () {
      this.loading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          resourceManagement: 21,
        })
        .then((res) => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function () {
      var accountIdList = this.$refs.child.accountIds;
      var companyId = this.$refs.child.companyId;
      var hostId = this.$refs.child.hostId;
      var jjson = {};
      jjson.companyId = companyId;
      if (null != accountIdList && "" != accountIdList) {
        jjson.accountIdList = accountIdList;
      }
      if (null != hostId && "" != hostId) {
        jjson.hostId = hostId;
      }
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等...",
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportAwsDedicatedHost(jjson).then((res) => {
        this.exportResponse(res);
        if (chooseType == true) {
          this.$refs.exportChild.loading = false;
        } else {
          this.$refs.exportChild.modal_loading = false;
        }
        // 关闭导出弹出框
        this.$refs.exportChild.exportModal = false;
      });
    },
    // 下载Excel 文件
    exportResponse: function (res) {
      let fileName = "AWS专用主机.xls";
      let blob = new Blob([res.data], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
      this.modal_loading = false;
      this.$Message.destroy();
      this.$Message.success("导出成功");
    },
  },
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>

</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/bsh/DedicatedHostingResource.vue